'use client';

/**
 * `useSendUsdcGift` — SDK gift mutation, delegated to the host's
 * implementation via {@link useGiftingHostContext}.
 *
 * The host (the Morfi web app) registers its existing
 * `frontend/src/hooks/gifts/use-send-gift.ts` implementation via
 * `<GiftingHostProvider value={{ useSendUsdcGift, … }}>`. This SDK
 * hook is the public re-export — consumers import from
 * `@morfi/backend-sdk-v2/client` and the SDK surface stays consistent
 * with the rest of the gift surface.
 *
 * See {@link host-context} for the rationale (TX builders stay in
 * frontend; SDK owns the public name + type contract).
 */
import { useGiftingHostContext } from './host-context.js';
export function useSendUsdcGift() {
  const {
    useSendUsdcGift: impl
  } = useGiftingHostContext();
  return impl();
}